<!-- Total Popup Dialog -->
<p-dialog
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="false"
  [showHeader]="false"
  styleClass="pos-dlg pos-dlg-xl premium-dialog payment-total-custom-dialog"
  [draggable]="false"
  [resizable]="false"
  (keydown)="dialogKeyDown.emit($event)"
  (onShow)="dialogShow.emit()"
  (onHide)="closeTotalDialogClicked.emit()"
>
  <div class="payment-dialog-wrapper">
    <!-- Header: what this is, and the amount to collect -->
    <div class="premium-header">
      <div class="premium-header-content">
        <h3 class="premium-title">
          {{ isQuotationMode ? "Quotation" : isExchangeOrder ? "Return payment" : "Take payment" }}
        </h3>
        <p class="premium-subtitle">
          {{
            isQuotationMode
              ? "Review the items and generate the quotation"
              : "Pick how the customer pays, then press Enter"
          }}
        </p>
      </div>
      <div class="header-due" *ngIf="!isQuotationMode">
        <span class="header-due__label">{{ isExchangeOrder ? "Return value" : "Amount due" }}</span>
        <span class="header-due__value num">₹{{ roundedTotal | number: "1.2-2" }}</span>
      </div>
      <button
        type="button"
        class="premium-close-btn"
        (click)="closeTotalDialogClicked.emit()"
        aria-label="Close dialog"
        title="Close (Esc)"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- Inside White Card Container -->
    <div class="payment-dialog-body-card">
      <div class="payment-dialog-content">
        <div class="customer-info-section mb-2">
          <div class="customer-info-row">
            <!-- Mobile Number field -->
            <div class="customer-field-group">
              <div class="customer-icon-badge">
                <i class="pi pi-phone"></i>
              </div>
              <div class="customer-field-content">
                <!-- <label class="customer-field-label">
              Mobile Number
              <span class="text-danger" *ngIf="isMobileMandatory">*</span>
            </label> -->
                <p-autoComplete
                  #mobileNumberAutocomplete
                  [ngModel]="mobileNumber"
                  (ngModelChange)="
                    onMobileNumberChange($event);
                    mobileNumberModelChange.emit($event)
                  "
                  [suggestions]="filteredCustomersForMobile"
                  (completeMethod)="
                    filterCustomersByMobileRequested.emit($event)
                  "
                  (onSelect)="onMobileNumberSelect($event)"
                  field="mobile_no"
                  [dropdown]="false"
                  [forceSelection]="false"
                  [minLength]="0"
                  [showEmptyMessage]="true"
                  emptyMessage="No customers found"
                  placeholder="Enter mobile number"
                  [tabindex]="201"
                  appendTo="body"
                  styleClass="customer-name-autocomplete-header"
                  inputStyleClass="form-control form-control-sm customer-input"
                  [readonly]="lockMobile"
                >
                  <ng-template let-customer pTemplate="item">
                    <div class="customer-option-header">
                      <div class="customer-name-text">
                        {{ customer.customer_name }}
                      </div>
                      <div class="customer-mobile-text">
                        {{ customer.mobile_no }}
                      </div>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
            <!-- Divider -->
            <div class="customer-field-divider"></div>
            <!-- Customer Name field -->
            <div class="customer-field-group">
              <div class="customer-icon-badge">
                <i class="pi pi-user"></i>
              </div>
              <div class="customer-field-content">
                <!-- <label class="customer-field-label">Customer Name</label> -->
                <p-autoComplete
                  #customerNameAutocomplete
                  [ngModel]="customerName"
                  (ngModelChange)="
                    onCustomerNameChange($event);
                    customerNameModelChange.emit($event)
                  "
                  [suggestions]="filteredCustomers"
                  (completeMethod)="filterCustomersRequested.emit($event)"
                  (onSelect)="onCustomerNameSelect($event)"
                  field="customer_name"
                  [dropdown]="false"
                  [forceSelection]="false"
                  [minLength]="0"
                  [maxlength]="30"
                  [showEmptyMessage]="true"
                  emptyMessage="No customers found"
                  placeholder="Enter customer name"
                  [tabindex]="202"
                  appendTo="body"
                  styleClass="customer-name-autocomplete-header"
                  inputStyleClass="form-control form-control-sm customer-input"
                  [readonly]="lockName"
                >
                  <ng-template let-customer pTemplate="item">
                    <div class="customer-option-header">
                      <div class="customer-name-text">
                        {{ customer.customer_name }}
                      </div>
                      <div class="customer-mobile-text">
                        {{ customer.mobile_no }}
                      </div>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>

            <!-- Divider (Pharmacy only) -->
            <div
              class="customer-field-divider"
              *ngIf="industryService.isPharmacy()"
            ></div>

            <!-- Doctor Name / Mobile Number field (Pharmacy only) -->
            <div
              class="customer-field-group"
              *ngIf="industryService.isPharmacy()"
            >
              <div
                class="customer-icon-badge cursor-pointer"
                (click)="openDoctorDialog()"
                title="Add / Manage Doctor & Hospital Details"
              >
                <i class="pi pi-id-card"></i>
              </div>
              <div class="customer-field-content">
                <p-autoComplete
                  #doctorNameAutocomplete
                  [ngModel]="
                    doctorName && doctorMobile
                      ? doctorName + ' - ' + doctorMobile
                      : doctorName || doctorMobile
                  "
                  (ngModelChange)="
                    onDoctorInfoChange($event);
                    doctorNameModelChange.emit(doctorName);
                    doctorMobileModelChange.emit(doctorMobile)
                  "
                  [suggestions]="filteredDoctors"
                  (completeMethod)="filterDoctorsRequested.emit($event)"
                  (onSelect)="onDoctorSelect($event)"
                  field="doctor_name"
                  [dropdown]="false"
                  [forceSelection]="false"
                  [minLength]="0"
                  [maxlength]="70"
                  [showEmptyMessage]="true"
                  emptyMessage="No doctors found"
                  placeholder="Enter Doctor Name / Mobile Number"
                  [tabindex]="203"
                  appendTo="body"
                  styleClass="customer-name-autocomplete-header"
                  inputStyleClass="form-control form-control-sm customer-input"
                >
                  <ng-template let-doc pTemplate="item">
                    <div class="customer-option-header">
                      <div class="customer-name-text">
                        {{ doc.doctor_name || doc.name || doc.doctorName }}
                      </div>
                      <div
                        class="customer-mobile-text"
                        *ngIf="doc.mobile_no || doc.mobile || doc.doctorMobile"
                      >
                        {{ doc.mobile_no || doc.mobile || doc.doctorMobile }}
                      </div>
                    </div>
                  </ng-template>
                </p-autoComplete>
              </div>
            </div>
          </div>
        </div>

        <!-- Scrollable Middle Body (Customer section & Footer remain fixed) -->
        <div class="payment-dialog-scrollable-body">
          <div
            class="exchange-confirmation-section"
            *ngIf="!isQuotationMode && showExchangeConfirmation"
          >
            <div class="alert alert-info mb-0">
              <h5 class="mb-3 text-center">
                <i class="pi pi-question-circle me-2"></i>
                Return Order Confirmation
              </h5>
              <p class="mb-3 text-center fs-5">
                You have an Return order with a total value of
                <strong>{{ exactTotal | currency: "INR" }}</strong
                >.
                <br />
                How would you like to handle this amount?
              </p>
              <div class="d-flex gap-3 justify-content-center mt-4">
                <button
                  type="button"
                  class="premium-btn premium-btn-secondary"
                  (click)="cancelExchangeConfirmationClicked.emit()"
                  aria-label="Cancel and return to payment options"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  *ngIf="isExchangeOrder && isAddToCreditSelected"
                  class="premium-btn premium-btn-success"
                  (click)="confirmExchangeAsCreditClicked.emit()"
                  aria-label="Add Return amount as credit for future use"
                >
                  <i class="pi pi-credit-card"></i>
                  Add as Credit
                </button>
                <button
                  type="button"
                  *ngIf="isExchangeOrder && !isAddToCreditSelected"
                  class="premium-btn premium-btn-primary"
                  (click)="confirmExchangeAsRefundClicked.emit()"
                  aria-label="Process refund for Return amount"
                >
                  <i class="pi pi-money-bill"></i>
                  Process Refund
                </button>
              </div>
            </div>
          </div>

          <!-- Payment Information Section (Hidden in Quotation Mode and Return Confirmation) -->
          <div *ngIf="!isQuotationMode && !showExchangeConfirmation">
            <!-- Payment Method Tabs — full width above both columns -->
            <div class="payment-tabs-section mb-2">
              <div class="payment-method-tabs">
                <button
                  type="button"
                  class="payment-tab-btn cash-tab"
                  [class.active]="session.state.activePaymentTab === 'Cash'"
                  (click)="onSelectPaymentTab('Cash')"
                >
                  <i class="pi pi-money-bill"></i>
                  <span>Cash</span>
                </button>
                <button
                  type="button"
                  class="payment-tab-btn card-tab"
                  [class.active]="session.state.activePaymentTab === 'Card'"
                  (click)="onSelectPaymentTab('Card')"
                  [disabled]="isExchangeOrder"
                >
                  <i class="pi pi-credit-card"></i>
                  <span>Card</span>
                </button>
                <button
                  type="button"
                  class="payment-tab-btn upi-tab"
                  [class.active]="session.state.activePaymentTab === 'UPI'"
                  (click)="onSelectPaymentTab('UPI')"
                  [disabled]="isExchangeOrder"
                >
                  <i class="pi pi-mobile"></i>
                  <span>UPI</span>
                </button>
                <button
                  type="button"
                  class="payment-tab-btn redeem-points-tab"
                  [class.active]="
                    session.state.activePaymentTab === 'Redeem Points'
                  "
                  (click)="onSelectPaymentTab('Redeem Points')"
                  [disabled]="!isExchangeOrder && isAnyPartPaymentEnabled"
                  *ngIf="showRedeemTab && isExchangeOrder"
                >
                  <i
                    class="pi"
                    [class.pi-gift]="!isExchangeOrder"
                    [class.pi-credit-card]="isExchangeOrder"
                  ></i>
                  <span>Add to Credit</span>
                </button>
                <button
                  type="button"
                  class="payment-tab-btn redeem-points-tab"
                  [class.active]="
                    session.state.activePaymentTab === 'Redeem Points'
                  "
                  (click)="onSelectPaymentTab('Redeem Points')"
                  [disabled]="!isExchangeOrder && isAnyPartPaymentEnabled"
                  *ngIf="!showRedeemTab && isExchangeOrder"
                >
                  <i
                    class="pi"
                    [class.pi-gift]="!isExchangeOrder"
                    [class.pi-credit-card]="isExchangeOrder"
                  ></i>
                  <span>{{ "Add to Credit" }}</span>
                </button>
                <button
                  type="button"
                  class="payment-tab-btn split-tab"
                  [class.active]="session.state.activePaymentTab === 'Split'"
                  (click)="onSelectPaymentTab('Split')"
                  [disabled]="
                    isExchangeOrder ||
                    hasNonGSTProducts ||
                    isAnyPartPaymentEnabled
                  "
                >
                  <i class="pi pi-clone"></i>
                  <span>Split</span>
                </button>
              </div>
            </div>

            <!-- One-tap amounts: exact due and the next round notes -->
            <div class="quick-tender" *ngIf="showQuickTender">
              <span class="quick-tender__label">
                {{ session.state.activePaymentTab === "Cash" ? "Cash received" : "Amount" }}
              </span>
              <div class="quick-tender__options">
                <button
                  type="button"
                  class="quick-tender__btn"
                  *ngFor="let amount of quickTenderOptions; let first = first"
                  [class.quick-tender__btn--exact]="first"
                  [class.is-selected]="isTenderSelected(amount)"
                  (mousedown)="preventFocus($event)"
                  (click)="setTenderAmount(amount)"
                >
                  <span class="quick-tender__hint">{{ first ? (session.state.activePaymentTab === "Cash" ? "Exact" : "Full amount") : "Note" }}</span>
                  <span class="num">₹{{ amount | number: "1.0-2" }}</span>
                </button>
              </div>
            </div>

            <!-- Payment Content Row: amounts (left) + keypad (right) -->
            <div class="row g-2">
              <!-- Left Side: Payment Amount Inputs + Summary + Loyalty -->
              <div class="col-lg-8 col-md-7">
                <!-- Payment Amount Inputs Section -->
                <div class="payment-amounts-section mb-3">
                  <!-- Cash Payment Tab -->
                  <div
                    *ngIf="session.state.activePaymentTab === 'Cash'"
                    class="payment-input-section"
                  >
                    <!-- Top Action Row: Aligned with Cash label when redeem is closed, or right-aligned at top when redeem is open -->
                    <div
                      class="d-flex align-items-center mb-2"
                      [ngClass]="
                        showRedeemCodeInput
                          ? 'justify-content-end'
                          : 'justify-content-between'
                      "
                    >
                      <label
                        class="form-label mb-0"
                        *ngIf="!showRedeemCodeInput"
                        ><span *ngIf="isExchangeOrder">Additional&nbsp;</span
                        >Cash<span *ngIf="isExchangeOrder"
                          >&nbsp;Received for Rounding</span
                        ></label
                      >
                      <div class="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          class="redeem-points-action-btn"
                          [class.active]="
                            showRedeemCodeInput && !isExchangeOrder
                          "
                          (click)="toggleRedeemCode()"
                          [disabled]="
                            !isExchangeOrder &&
                            (session.state.isPartPaymentCash ||
                              isAnyPartPaymentEnabled)
                          "
                          *ngIf="showRedeemTab && !isExchangeOrder"
                        >
                          <i
                            class="pi"
                            [class.pi-gift]="!isExchangeOrder"
                            [class.pi-credit-card]="isExchangeOrder"
                          ></i>
                          <span> Redeem </span>
                        </button>
                        <div class="form-check form-switch mb-0">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [ngModel]="session.state.isPartPaymentCash"
                            (ngModelChange)="onPartPaymentCashChange($event)"
                            id="partPaymentCash"
                            [disabled]="
                              isExchangeOrder ||
                              hasNonGSTProducts ||
                              session.state.isPartPaymentCard ||
                              session.state.isPartPaymentUPI
                            "
                          />
                          <label class="form-check-label" for="partPaymentCash">
                            Credit
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Below Buttons: Redeem Details Section (shown when redeem button is clicked) -->
                    <div class="mb-3" *ngIf="showRedeemCodeInput">
                      <div class="row g-2">
                        <label>Redeem Detail</label>
                        <div
                          [ngClass]="
                            session.state.availableCreditAmount > 0
                              ? 'col-6'
                              : 'col-12'
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="session.state.selectedInvoiceNo"
                            (input)="invoiceNumberInput.emit()"
                            placeholder="Enter redeem code"
                            required
                          />
                        </div>
                        <div
                          class="col-6"
                          *ngIf="session.state.availableCreditAmount > 0"
                        >
                          <p-inputNumber
                            [(ngModel)]="session.state.redeemCreditAmount"
                            mode="decimal"
                            locale="en-US"
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [useGrouping]="false"
                            prefix="₹"
                            [min]="0"
                            [max]="session.state.availableCreditAmount"
                            styleClass="w-100"
                            placeholder="Enter redeem amount"
                            (onInput)="redeemCreditAmountInput.emit()"
                            [disabled]="true"
                          >
                          </p-inputNumber>
                        </div>
                        <div
                          class="col-12"
                          *ngIf="session.state.availableCreditAmount > 0"
                        >
                          <div
                            class="alert alert-info py-1 px-2 mb-0 d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <i class="pi pi-info-circle me-1"></i>
                              <small
                                >Available Credit: ₹{{
                                  session.state.availableCreditAmount
                                    | number: "1.2-2"
                                }}</small
                              >
                            </div>
                            <small class="text-muted">
                              Available Credit Balance:
                              <strong class="text-success">
                                ₹{{
                                  session.state.availableCreditAmount -
                                    session.state.redeemCreditAmount
                                    | number: "1.2-2"
                                }}
                              </strong>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Below Redeem Details: Cash Label (shown when redeem button is clicked) -->
                    <div class="mb-2" *ngIf="showRedeemCodeInput">
                      <label class="form-label mb-0"
                        ><span *ngIf="isExchangeOrder">Additional&nbsp;</span
                        >Cash<span *ngIf="isExchangeOrder"
                          >&nbsp;Received for Rounding</span
                        ></label
                      >
                    </div>

                    <!-- Below Cash Label: Cash Amount Input Box -->
                    <div class="row g-2">
                      <div class="col-12">
                        <p-inputNumber
                          [(ngModel)]="session.state.cashAmount"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="2"
                          [useGrouping]="false"
                          prefix="₹"
                          [min]="0"
                          styleClass="w-100"
                          placeholder="Enter cash amount"
                          (onInput)="cashAmountInput.emit()"
                        >
                        </p-inputNumber>
                        <div
                          class="alert alert-warning mt-2"
                          *ngIf="
                            session.state.isPartPaymentCash &&
                            (!mobileNumber || mobileNumber.length !== 10)
                          "
                        >
                          <i class="pi pi-exclamation-triangle me-2"></i>
                          <strong>Mobile Number Required</strong>
                          <p class="mb-0 mt-1">
                            Please enter a valid 10-digit mobile number to add
                            credit.
                          </p>
                        </div>
                      </div>

                      <div class="col-12" *ngIf="isExchangeOrder">
                        <label class="form-label"
                          >Refund Cash Amount
                          <small class="text-muted">(Auto-calculated)</small>
                        </label>
                        <p-inputNumber
                          [ngModel]="session.state.refundCashAmount"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="2"
                          [useGrouping]="false"
                          prefix="₹"
                          [min]="0"
                          [max]="absoluteBalance"
                          styleClass="w-100 auto-calculated-field"
                          placeholder="Auto-calculated refund amount"
                          [disabled]="true"
                        >
                        </p-inputNumber>
                      </div>
                    </div>
                  </div>

                  <!-- Card Payment Tab -->
                  <div
                    *ngIf="session.state.activePaymentTab === 'Card'"
                    class="payment-input-section"
                  >
                    <!-- Top Action Row: Aligned with Card label when redeem is closed, or right-aligned at top when redeem is open -->
                    <div
                      class="d-flex align-items-center mb-2"
                      [ngClass]="
                        showRedeemCodeInput
                          ? 'justify-content-end'
                          : 'justify-content-between'
                      "
                    >
                      <label
                        class="form-label mb-0"
                        *ngIf="!showRedeemCodeInput"
                        >Card Amount</label
                      >
                      <div class="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          class="redeem-points-action-btn"
                          [class.active]="
                            showRedeemCodeInput && !isExchangeOrder
                          "
                          (click)="toggleRedeemCode()"
                          [disabled]="
                            !isExchangeOrder &&
                            (session.state.isPartPaymentCard ||
                              isAnyPartPaymentEnabled)
                          "
                          *ngIf="showRedeemTab && !isExchangeOrder"
                        >
                          <i
                            class="pi"
                            [class.pi-gift]="!isExchangeOrder"
                            [class.pi-credit-card]="isExchangeOrder"
                          ></i>
                          <span> Redeem </span>
                        </button>
                        <div class="form-check form-switch mb-0">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [ngModel]="session.state.isPartPaymentCard"
                            (ngModelChange)="onPartPaymentCardChange($event)"
                            id="partPaymentCard"
                            [disabled]="
                              isExchangeOrder ||
                              hasNonGSTProducts ||
                              session.state.isPartPaymentCash ||
                              session.state.isPartPaymentUPI
                            "
                          />
                          <label class="form-check-label" for="partPaymentCard">
                            Credit
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Below Buttons: Redeem Details Section (shown when redeem button is clicked) -->
                    <div class="mb-3" *ngIf="showRedeemCodeInput">
                      <div class="row g-2">
                        <label>Redeem Detail</label>

                        <div
                          [ngClass]="
                            session.state.availableCreditAmount > 0
                              ? 'col-6'
                              : 'col-12'
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="session.state.selectedInvoiceNo"
                            (input)="invoiceNumberInput.emit()"
                            placeholder="Enter redeem code"
                            required
                          />
                        </div>
                        <div
                          class="col-6"
                          *ngIf="session.state.availableCreditAmount > 0"
                        >
                          <p-inputNumber
                            [(ngModel)]="session.state.redeemCreditAmount"
                            mode="decimal"
                            locale="en-US"
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [useGrouping]="false"
                            prefix="₹"
                            [min]="0"
                            [max]="session.state.availableCreditAmount"
                            styleClass="w-100"
                            placeholder="Enter redeem amount"
                            (onInput)="redeemCreditAmountInput.emit()"
                            [disabled]="true"
                          >
                          </p-inputNumber>
                        </div>
                        <div
                          class="col-12"
                          *ngIf="session.state.availableCreditAmount > 0"
                        >
                          <div
                            class="alert alert-info py-1 px-2 mb-0 d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <i class="pi pi-info-circle me-1"></i>
                              <small
                                >Available Credit: ₹{{
                                  session.state.availableCreditAmount
                                    | number: "1.2-2"
                                }}</small
                              >
                            </div>
                            <small class="text-muted">
                              Available Credit Balance:
                              <strong class="text-success">
                                ₹{{
                                  session.state.availableCreditAmount -
                                    session.state.redeemCreditAmount
                                    | number: "1.2-2"
                                }}
                              </strong>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Below Redeem Details: Card Label (shown when redeem button is clicked) -->
                    <div class="mb-2" *ngIf="showRedeemCodeInput">
                      <label class="form-label mb-0">Card Amount</label>
                    </div>

                    <!-- Below Card Label: Card inputs -->
                    <div class="row g-2">
                      <div class="col-12">
                        <p-inputNumber
                          [(ngModel)]="session.state.cardDetails.amount"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="2"
                          [useGrouping]="false"
                          prefix="₹"
                          [min]="0"
                          styleClass="w-100"
                          placeholder="Enter card amount"
                          (onInput)="cardAmountInput.emit()"
                        >
                        </p-inputNumber>
                        <div
                          class="alert alert-warning mt-2"
                          *ngIf="
                            session.state.isPartPaymentCard &&
                            (!mobileNumber || mobileNumber.length !== 10)
                          "
                        >
                          <i class="pi pi-exclamation-triangle me-2"></i>
                          <strong>Mobile Number Required</strong>
                          <p class="mb-0 mt-1">
                            Please enter a valid 10-digit mobile number to add
                            credit.
                          </p>
                        </div>
                      </div>

                      <div class="col-6">
                        <label class="form-label">Cardholder Name</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="session.state.cardDetails.name"
                          placeholder="Enter name"
                        />
                      </div>
                      <div class="col-6">
                        <label class="form-label">Transaction ID</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="session.state.cardDetails.transactionId"
                          placeholder="Enter transaction ID"
                        />
                      </div>
                    </div>
                  </div>

                  <!-- UPI Payment Tab -->
                  <div
                    *ngIf="session.state.activePaymentTab === 'UPI'"
                    class="payment-input-section upi_section"
                  >
                    <!-- Top Action Row: Aligned with UPI label when redeem is closed, or right-aligned at top when redeem is open -->
                    <div
                      class="d-flex align-items-center mb-2"
                      [ngClass]="
                        showRedeemCodeInput || isPgIntegrationEnabled
                          ? 'justify-content-end'
                          : 'justify-content-between'
                      "
                    >
                      <label
                        class="form-label mb-0"
                        *ngIf="!showRedeemCodeInput && !isPgIntegrationEnabled"
                        >UPI Amount</label
                      >
                      <div class="d-flex align-items-center gap-2">
                        <button
                          type="button"
                          class="redeem-points-action-btn"
                          [class.active]="
                            showRedeemCodeInput && !isExchangeOrder
                          "
                          (click)="toggleRedeemCode()"
                          [disabled]="
                            !isExchangeOrder &&
                            (session.state.isPartPaymentUPI ||
                              isAnyPartPaymentEnabled)
                          "
                          *ngIf="showRedeemTab && !isExchangeOrder"
                        >
                          <i
                            class="pi"
                            [class.pi-gift]="!isExchangeOrder"
                            [class.pi-credit-card]="isExchangeOrder"
                          ></i>
                          <span> Redeem </span>
                        </button>
                        <div
                          class="form-check form-switch mb-0"
                          *ngIf="!isPgIntegrationEnabled"
                        >
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [ngModel]="session.state.isPartPaymentUPI"
                            (ngModelChange)="onPartPaymentUPIChange($event)"
                            id="partPaymentUPI"
                            [disabled]="
                              isExchangeOrder ||
                              hasNonGSTProducts ||
                              session.state.isPartPaymentCash ||
                              session.state.isPartPaymentCard
                            "
                          />
                          <label class="form-check-label" for="partPaymentUPI">
                            Credit
                          </label>
                        </div>
                      </div>
                    </div>

                    <!-- Below Buttons: Redeem Details Section (shown when redeem button is clicked) -->
                    <div class="mb-3" *ngIf="showRedeemCodeInput">
                      <div class="row g-2">
                        <label>Redeem Detail</label>

                        <div
                          [ngClass]="
                            session.state.availableCreditAmount > 0
                              ? 'col-6'
                              : 'col-12'
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="session.state.selectedInvoiceNo"
                            (input)="invoiceNumberInput.emit()"
                            placeholder="Enter redeem code"
                            required
                          />
                        </div>
                        <div
                          class="col-6"
                          *ngIf="session.state.availableCreditAmount > 0"
                        >
                          <p-inputNumber
                            [(ngModel)]="session.state.redeemCreditAmount"
                            mode="decimal"
                            locale="en-US"
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [useGrouping]="false"
                            prefix="₹"
                            [min]="0"
                            [max]="session.state.availableCreditAmount"
                            styleClass="w-100"
                            placeholder="Enter redeem amount"
                            (onInput)="redeemCreditAmountInput.emit()"
                            [disabled]="true"
                          >
                          </p-inputNumber>
                        </div>
                        <div
                          class="col-12"
                          *ngIf="session.state.availableCreditAmount > 0"
                        >
                          <div
                            class="alert alert-info py-1 px-2 mb-0 d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <i class="pi pi-info-circle me-1"></i>
                              <small
                                >Available Credit: ₹{{
                                  session.state.availableCreditAmount
                                    | number: "1.2-2"
                                }}</small
                              >
                            </div>
                            <small class="text-muted">
                              Available Credit Balance:
                              <strong class="text-success">
                                ₹{{
                                  session.state.availableCreditAmount -
                                    session.state.redeemCreditAmount
                                    | number: "1.2-2"
                                }}
                              </strong>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Below Redeem Details: UPI Amount Label (shown when redeem button is clicked) -->
                    <div
                      class="mb-2"
                      *ngIf="showRedeemCodeInput && !isPgIntegrationEnabled"
                    >
                      <label class="form-label mb-0">UPI Amount</label>
                    </div>

                    <div class="row g-2">
                      <div class="col-12" *ngIf="!isPgIntegrationEnabled">
                        <p-inputNumber
                          [(ngModel)]="session.state.upiDetails.upiAmount"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="2"
                          [useGrouping]="false"
                          prefix="₹"
                          [min]="0"
                          styleClass="w-100"
                          placeholder="Enter UPI amount"
                          (onInput)="upiAmountInput.emit()"
                        >
                        </p-inputNumber>
                        <div
                          class="alert alert-warning mt-2"
                          *ngIf="
                            session.state.isPartPaymentUPI &&
                            (!mobileNumber || mobileNumber.length !== 10)
                          "
                        >
                          <i class="pi pi-exclamation-triangle me-2"></i>
                          <strong>Mobile Number Required</strong>
                          <p class="mb-0 mt-1">
                            Please enter a valid 10-digit mobile number to add
                            credit.
                          </p>
                        </div>
                      </div>

                      <div class="col-6" *ngIf="!isPgIntegrationEnabled">
                        <label class="form-label">UPI ID</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="session.state.upiDetails.upiId"
                          placeholder="Enter UPI ID"
                        />
                      </div>
                      <div class="col-6" *ngIf="!isPgIntegrationEnabled">
                        <label class="form-label">Transaction ID</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="session.state.upiDetails.transactionId"
                          placeholder="Enter transaction ID"
                        />
                      </div>

                      <div
                        class="col-12"
                        *ngIf="isPgIntegrationEnabled && !upiQrCodeImage"
                      >
                        <div class="alert alert-info mb-0">
                          <i class="pi pi-qrcode me-2"></i>
                          QR code is being generated for UPI payment.
                        </div>
                      </div>

                      <div class="col-12" *ngIf="isPgIntegrationEnabled">
                        <!-- && upiQrCodeImage -->
                        <div class="upi-qr-card">
                          <div
                            class="upi-qr-logo d-flex justify-content-start align-items-center w-100"
                          >
                            <img
                              src="/assets/Elixirpay_Logo_Blue.png"
                              alt=""
                              srcset=""
                              width="150px"
                              height="30px"
                            />
                            <div class="upi-qr-title">Scan QR to Pay</div>
                          </div>
                          <div class="upi-qr-subtitle">
                            Complete the payment before the timer expires.
                          </div>
                          <div class="upi-qr-image-wrap">
                            <img
                              [src]="upiQrCodeImage"
                              alt="UPI QR Code"
                              class="upi-qr-image"
                            />
                          </div>
                          <div class="text-center mt-0">
                            <small>
                              Payment processed by
                              <span class="text-primary">Omiware</span>
                            </small>
                          </div>
                          <div class="upi-qr-timer">
                            Expires in {{ qrCountdownLabel }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Add to Credit Tab: mobile number is mandatory -->
                  <div
                    *ngIf="
                      isExchangeOrder &&
                      session.state.activePaymentTab === 'Redeem Points' &&
                      (!mobileNumber || mobileNumber.length !== 10)
                    "
                    class="payment-input-section"
                  >
                    <div class="alert alert-warning mb-0">
                      <i class="pi pi-exclamation-triangle me-2"></i>
                      <strong>Mobile Number Required</strong>
                      <p class="mb-0 mt-1">
                        Please enter a valid 10-digit mobile number to add
                        credit.
                      </p>
                    </div>
                  </div>

                  <!-- Redeem Points / Add to Credit Payment Tab -->
                  <!-- <div
                    *ngIf="session.state.activePaymentTab === 'Redeem Points'"
                    class="payment-input-section"
                  >
                    <div *ngIf="isExchangeOrder" class="text-center">
                      <div class="alert alert-success">
                        <i class="pi pi-credit-card me-2"></i>
                        <strong>Add to Credit</strong>
                        <p class="mb-0 mt-2">
                          Return amount of
                          <strong>{{
                            roundedTotal | currency: "INR" : "symbol" : "1.2-2"
                          }}</strong>
                          will be added to customer credit.
                        </p>
                        <small class="text-muted"
                          >No payment required - amount will be credited to
                          customer account.</small
                        >
                      </div>
                      <div
                        class="alert alert-warning mt-2"
                        *ngIf="!mobileNumber || mobileNumber.length !== 10"
                      >
                        <i class="pi pi-exclamation-triangle me-2"></i>
                        <strong>Mobile Number Required</strong>
                        <p class="mb-0 mt-1">
                          Please enter a valid 10-digit mobile number to add
                          credit.
                        </p>
                      </div>
                    </div>

                    <div *ngIf="!isExchangeOrder" class="row g-2">
                      <div class="col-12">
                        <label class="form-label">Redeem Code</label>
                        <input
                          type="text"
                          class="form-control form-control-sm"
                          [(ngModel)]="session.state.selectedInvoiceNo"
                          (input)="invoiceNumberInput.emit()"
                          placeholder="Enter redeem code"
                          required
                        />
                      </div>
                      <div class="col-12">
                        <label class="form-label">Amount</label>
                        <p-inputNumber
                          [(ngModel)]="session.state.redeemCreditAmount"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="2"
                          [useGrouping]="false"
                          prefix="₹"
                          [min]="0"
                          [max]="session.state.availableCreditAmount"
                          styleClass="w-100"
                          placeholder="0"
                          (onInput)="redeemCreditAmountInput.emit()"
                        >
                        </p-inputNumber>
                      </div>
                      <div
                        class="col-12"
                        *ngIf="session.state.availableCreditAmount > 0"
                      >
                        <div class="alert alert-info">
                          <i class="pi pi-info-circle"></i>
                          Available Credit: ₹{{
                            session.state.availableCreditAmount
                              | number: "1.2-2"
                          }}
                          <small class="text-muted"  *ngIf="session.state.redeemCreditAmount > 0">
                            Available Credit Balance:
                            <strong class="text-success">
                              ₹{{
                                session.state.availableCreditAmount - session.state.redeemCreditAmount
                                  | number: "1.2-2"
                              }}
                            </strong>
                          </small>
                        </div>
                      </div>
                    </div>
                  </div> -->

                  <!-- Split Payment Tab -->
                  <div
                    *ngIf="session.state.activePaymentTab === 'Split'"
                    class="payment-input-section split-payment-section"
                  >
                    <!-- Top Action Row: Right-aligned Redeem button -->
                    <div
                      class="d-flex justify-content-end align-items-center mb-2"
                    >
                      <button
                        type="button"
                        class="redeem-points-action-btn"
                        [class.active]="showRedeemCodeInput && !isExchangeOrder"
                        (click)="toggleRedeemCode()"
                        [disabled]="!isExchangeOrder && isAnyPartPaymentEnabled"
                        *ngIf="showRedeemTab && !isExchangeOrder"
                      >
                        <i
                          class="pi"
                          [class.pi-gift]="!isExchangeOrder"
                          [class.pi-credit-card]="isExchangeOrder"
                        ></i>
                        <span> Redeem </span>
                      </button>
                    </div>

                    <!-- Below Buttons: Redeem Details Section (shown when redeem button is clicked) -->
                    <div class="mb-3" *ngIf="showRedeemCodeInput">
                      <div class="row g-2">
                        <label>Redeem Detail</label>

                        <div
                          [ngClass]="
                            session.state.availableCreditAmount > 0
                              ? 'col-6'
                              : 'col-12'
                          "
                        >
                          <input
                            type="text"
                            class="form-control"
                            [(ngModel)]="session.state.selectedInvoiceNo"
                            (input)="invoiceNumberInput.emit()"
                            placeholder="Enter redeem code"
                            required
                          />
                        </div>
                        <div
                          class="col-6"
                          *ngIf="session.state.availableCreditAmount > 0"
                        >
                          <p-inputNumber
                            [(ngModel)]="session.state.redeemCreditAmount"
                            mode="decimal"
                            locale="en-US"
                            [minFractionDigits]="0"
                            [maxFractionDigits]="2"
                            [useGrouping]="false"
                            prefix="₹"
                            [min]="0"
                            [max]="session.state.availableCreditAmount"
                            styleClass="w-100"
                            placeholder="Enter redeem amount"
                            (onInput)="redeemCreditAmountInput.emit()"
                            [disabled]="true"
                          >
                          </p-inputNumber>
                        </div>
                        <div
                          class="col-12"
                          *ngIf="session.state.availableCreditAmount > 0"
                        >
                          <div
                            class="alert alert-info py-1 px-2 mb-0 d-flex justify-content-between align-items-center"
                          >
                            <div>
                              <i class="pi pi-info-circle me-1"></i>
                              <small
                                >Available Credit: ₹{{
                                  session.state.availableCreditAmount
                                    | number: "1.2-2"
                                }}</small
                              >
                            </div>
                            <small class="text-muted">
                              Available Credit Balance:
                              <strong class="text-success">
                                ₹{{
                                  session.state.availableCreditAmount -
                                    session.state.redeemCreditAmount
                                    | number: "1.2-2"
                                }}
                              </strong>
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row g-3">
                      <div class="col-12 col-md-4">
                        <label class="form-label">Cash</label>
                        <p-inputNumber
                          [(ngModel)]="session.state.splitPaymentAmounts.cash"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="2"
                          [useGrouping]="false"
                          prefix="₹"
                          [min]="0"
                          styleClass="w-100 split-input"
                          placeholder="Rs 0"
                          (onInput)="splitAmountInput.emit()"
                        >
                        </p-inputNumber>
                      </div>
                      <div class="col-12 col-md-4">
                        <label class="form-label">Card</label>
                        <p-inputNumber
                          [(ngModel)]="session.state.splitPaymentAmounts.card"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="2"
                          [useGrouping]="false"
                          prefix="₹"
                          [min]="0"
                          styleClass="w-100 split-input"
                          placeholder="Rs 0"
                          (onInput)="splitAmountInput.emit()"
                        >
                        </p-inputNumber>
                      </div>
                      <div class="col-12 col-md-4">
                        <label class="form-label">UPI</label>
                        <p-inputNumber
                          [(ngModel)]="session.state.splitPaymentAmounts.upi"
                          mode="decimal"
                          locale="en-US"
                          [minFractionDigits]="0"
                          [maxFractionDigits]="2"
                          [useGrouping]="false"
                          prefix="₹"
                          [min]="0"
                          styleClass="w-100 split-input"
                          placeholder="Rs 0"
                          (onInput)="splitAmountInput.emit()"
                        >
                        </p-inputNumber>
                      </div>
                    </div>

                    <!-- Card Details (shown when card amount > 0) -->
                    <div
                      class="row g-2 mt-2"
                      *ngIf="session.state.splitPaymentAmounts.card > 0"
                    >
                      <div class="col-6">
                        <label class="form-label">Cardholder Name</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="session.state.cardDetails.name"
                          placeholder="Enter name"
                        />
                      </div>
                      <div class="col-6">
                        <label class="form-label">Transaction ID</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="session.state.cardDetails.transactionId"
                          placeholder="Enter transaction ID"
                        />
                      </div>
                    </div>

                    <!-- UPI Details (shown when UPI amount > 0) -->
                    <div
                      class="row g-2 mt-2"
                      *ngIf="session.state.splitPaymentAmounts.upi > 0"
                    >
                      <div class="col-6">
                        <label class="form-label">UPI ID</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="session.state.upiDetails.upiId"
                          placeholder="Enter UPI ID"
                        />
                      </div>
                      <div class="col-6">
                        <label class="form-label">Transaction ID</label>
                        <input
                          type="text"
                          class="form-control"
                          [(ngModel)]="session.state.upiDetails.transactionId"
                          placeholder="Enter transaction ID"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Payment Summary Section (Matching screenshot UI) -->
                <div class="payment-summary-card">
                  <!-- Total Amount -->
                  <div class="summary-stat-item">
                    <div class="summary-icon-circle green-badge">
                      <i class="pi pi-wallet"></i>
                    </div>
                    <div class="summary-stat-info">
                      <span class="summary-stat-label">Total Amount</span>
                      <span class="summary-stat-value green-text"
                        >₹{{ roundedTotal | number: "1.2-2" }}</span
                      >
                    </div>
                  </div>

                  <!-- Vertical Divider -->
                  <div class="summary-stat-divider"></div>

                  <!-- Paid Amount -->
                  <div class="summary-stat-item">
                    <div class="summary-icon-circle blue-badge">
                      <i class="pi pi-credit-card"></i>
                    </div>
                    <div class="summary-stat-info">
                      <span class="summary-stat-label">Paid Amount</span>
                      <span class="summary-stat-value blue-text"
                        >₹{{ paidAmount | number: "1.2-2" }}</span
                      >
                    </div>
                  </div>

                  <!-- Vertical Divider -->
                  <!-- <div class="summary-stat-divider"></div> -->

                  <!-- TIP Amount -->
                  <!-- <div class="summary-stat-item">
              <div class="summary-icon-circle orange-badge">
                <i class="pi pi-tag"></i>
              </div>
              <div class="summary-stat-info">
                <span class="summary-stat-label">TIP Amount</span>
                <span class="summary-stat-value orange-text"
                  >₹{{ tipAmount | number: "1.2-2" }}</span
                >
              </div>
            </div> -->

                  <!-- Vertical Divider -->
                  <div class="summary-stat-divider"></div>

                  <!-- Balance Amount -->
                  <div class="summary-stat-item">
                    <div class="summary-icon-circle purple-badge">
                      <i class="pi pi-sliders-h"></i>
                    </div>
                    <div class="summary-stat-info">
                      <span class="summary-stat-label">{{ balanceLabel }}</span>
                      <span
                        class="summary-stat-value"
                        [ngClass]="
                          isBalanceNegative ? 'refund-text' : 'dark-text'
                        "
                        >₹{{ balanceAmount | number: "1.2-2" }}</span
                      >
                    </div>
                  </div>
                </div>

                <!-- Loyalty Section -->
                <div
                  class="loyalty-payment-section mt-2"
                  *ngIf="loyalty.hasLoyaltyPoints() && !isExchangeOrder"
                >
                  <div class="loyalty-header">
                    <i class="pi pi-gift"></i>
                    <span>Use Loyalty Points</span>
                  </div>
                  <div class="loyalty-info-grid">
                    <div class="loyalty-info-item">
                      <span class="loyalty-label">Available Points:</span>
                      <span class="loyalty-value"
                        >{{ loyalty.loyaltyPoints }} Points</span
                      >
                    </div>
                    <div class="loyalty-info-item">
                      <span class="loyalty-label">Loyalty Amount:</span>
                      <span class="loyalty-value"
                        >₹{{ loyalty.loyaltyAmount | number: "1.2-2" }}</span
                      >
                    </div>
                    <div class="loyalty-info-item">
                      <span class="loyalty-label">Expiry:</span>
                      <span
                        class="loyalty-value"
                        [ngClass]="loyalty.getLoyaltyExpiryClass()"
                      >
                        <i
                          class="pi"
                          [ngClass]="
                            loyalty.isLoyaltyExpired()
                              ? 'pi-times-circle'
                              : 'pi-calendar'
                          "
                        ></i>
                        {{ loyalty.getLoyaltyExpiryText() }}
                      </span>
                    </div>
                  </div>
                  <div
                    class="alert alert-danger mt-2 mb-2"
                    *ngIf="loyalty.isLoyaltyExpired()"
                  >
                    <i class="pi pi-times-circle me-2"></i>
                    <small
                      ><strong>Loyalty Points Expired!</strong> Your loyalty
                      points have expired and cannot be redeemed.</small
                    >
                  </div>
                  <div
                    class="alert alert-warning mt-2 mb-2"
                    *ngIf="
                      !loyalty.isLoyaltyExpired() &&
                      loyalty.getLoyaltyValidationMessage(
                        isExchangeOrder,
                        roundedTotal
                      )
                    "
                  >
                    <i class="pi pi-exclamation-triangle me-2"></i>
                    <small>{{
                      loyalty.getLoyaltyValidationMessage(
                        isExchangeOrder,
                        roundedTotal
                      )
                    }}</small>
                  </div>
                  <div class="loyalty-input-section">
                    <div
                      class="d-flex justify-content-between align-items-center mb-1"
                    >
                      <label class="form-label mb-0"
                        >Enter Loyalty Points</label
                      >
                      <small
                        class="loyalty-expiry-badge"
                        [ngClass]="loyalty.getLoyaltyExpiryClass()"
                        *ngIf="
                          loyalty.customerLoyaltyData?.loyality_membership
                            ?.expiry_date
                        "
                      >
                        <i
                          class="pi"
                          [ngClass]="
                            loyalty.isLoyaltyExpired()
                              ? 'pi-times-circle'
                              : 'pi-calendar'
                          "
                        ></i>
                        {{ loyalty.getLoyaltyExpiryText() }}
                      </small>
                    </div>
                    <p-inputNumber
                      [(ngModel)]="loyalty.loyaltyPointsInput"
                      mode="decimal"
                      locale="en-US"
                      [minFractionDigits]="0"
                      [maxFractionDigits]="0"
                      [useGrouping]="false"
                      [min]="0"
                      [max]="loyalty.getMaxRedeemablePoints()"
                      styleClass="w-100"
                      placeholder="0"
                      (onInput)="loyalty.onLoyaltyPointsInput(roundedTotal)"
                      [disabled]="
                        !loyalty.canUseLoyalty(isExchangeOrder, roundedTotal)
                      "
                    >
                    </p-inputNumber>
                    <small
                      class="text-muted"
                      *ngIf="!loyalty.isLoyaltyExpired()"
                      >Maximum: {{ loyalty.getMaxRedeemablePoints() }} Points
                      (₹{{
                        loyalty.getMaxRedeemableAmount() | number: "1.2-2"
                      }})</small
                    >
                    <small
                      class="text-danger"
                      *ngIf="loyalty.isLoyaltyExpired()"
                    >
                      <i class="pi pi-ban me-1"></i>
                      Cannot redeem expired loyalty points
                    </small>
                    <div
                      class="mt-2"
                      *ngIf="
                        loyalty.loyaltyPointsInput > 0 &&
                        !loyalty.isLoyaltyExpired()
                      "
                    >
                      <small class="text-success">
                        <i class="pi pi-check-circle me-1"></i>
                        Using {{ loyalty.loyaltyPointsInput }} points = ₹{{
                          loyalty.loyaltyPaymentAmount | number: "1.2-2"
                        }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /Left Side -->

              <!-- Right Side: Numeric Keypad -->
              <div class="col-lg-4 col-md-5">
                <div class="numeric-keypad">
                  <div class="keypad-title">Quick Keypad</div>
                  <div class="keypad-grid">
                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="7"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('7')"
                      tabindex="-1"
                    >
                      7
                    </button>
                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="8"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('8')"
                      tabindex="-1"
                    >
                      8
                    </button>
                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="9"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('9')"
                      tabindex="-1"
                    >
                      9
                    </button>

                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="4"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('4')"
                      tabindex="-1"
                    >
                      4
                    </button>
                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="5"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('5')"
                      tabindex="-1"
                    >
                      5
                    </button>
                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="6"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('6')"
                      tabindex="-1"
                    >
                      6
                    </button>

                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="1"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('1')"
                      tabindex="-1"
                    >
                      1
                    </button>
                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="2"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('2')"
                      tabindex="-1"
                    >
                      2
                    </button>
                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="3"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('3')"
                      tabindex="-1"
                    >
                      3
                    </button>

                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="."
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('.')"
                      tabindex="-1"
                    >
                      .
                    </button>
                    <button
                      type="button"
                      class="keypad-btn"
                      data-keypad="0"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadInput('0')"
                      tabindex="-1"
                    >
                      0
                    </button>
                    <button
                      type="button"
                      class="keypad-btn backspace-btn"
                      data-keypad="backspace"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadBackspace()"
                      tabindex="-1"
                      aria-label="Backspace"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.9"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="backspace-icon"
                      >
                        <path
                          d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"
                        ></path>
                        <line x1="18" y1="9" x2="12" y2="15"></line>
                        <line x1="12" y1="9" x2="18" y2="15"></line>
                      </svg>
                    </button>

                    <button
                      type="button"
                      class="keypad-btn clear-btn"
                      data-keypad="clear"
                      (mousedown)="preventFocus($event)"
                      (click)="onKeypadClear()"
                      tabindex="-1"
                    >
                      CLEAR ALL
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Quotation Information Section (Shown in Quotation Mode) -->
          <div class="row g-2" *ngIf="isQuotationMode">
            <div class="col-12">
              <div class="quotation-summary-section">
                <h6 class="mb-3">
                  <i class="pi pi-file-edit me-2"></i>
                  Quotation Summary
                </h6>

                <!-- Quotation Validity -->
                <div class="row g-2 mb-3">
                  <div class="col-md-6">
                    <label class="form-label">Quotation Valid Until:</label>
                    <p-calendar
                      [ngModel]="quotationValidityDate"
                      (ngModelChange)="onQuotationValidityDateChange($event)"
                      [showIcon]="true"
                      [minDate]="minValidityDate"
                      [maxDate]="maxValidityDate"
                      dateFormat="dd/mm/yy"
                      placeholder="Select validity date"
                      appendTo="body"
                      class="w-100"
                    >
                    </p-calendar>
                  </div>
                </div>

                <!-- Quotation Items Summary -->
                <div class="quotation-items-summary">
                  <div class="table-responsive">
                    <table class="table table-sm table-bordered">
                      <thead class="table-light">
                        <tr>
                          <th>Item</th>
                          <th>Qty</th>
                          <th>Price</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let product of products">
                          <td>{{ product.name }}</td>
                          <td>{{ product.increaseQuantity }}</td>
                          <td>
                            {{
                              (isWholesaleMode
                                ? product.wholesaleprice
                                : product.sellingprice
                              ) | currency: "INR" : "symbol" : "1.2-2"
                            }}
                          </td>
                          <td>
                            {{
                              (isWholesaleMode
                                ? product.wholesaleprice
                                : product.sellingprice) *
                                product.increaseQuantity
                                | currency: "INR" : "symbol" : "1.2-2"
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot class="table-secondary">
                        <tr>
                          <th colspan="3">Estimated Total:</th>
                          <th>
                            {{
                              exactTotal | currency: "INR" : "symbol" : "1.2-2"
                            }}
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End of payment-dialog-scrollable-body -->

        <!-- End of payment-dialog-content -->
      </div>
      <!-- End of payment-dialog-body-card -->
    </div>

    <!-- Footer: secondary first, the one primary action last -->
    <div class="premium-footer payment-footer">
      <!-- Standard footer -->
      <ng-container *ngIf="!isAnyPartPaymentEnabled">
        <div class="exact-round-card">
          <i class="pi pi-info-circle exact-info-icon"></i>
          <span class="exact-round-text">
            Exact: ₹{{ exactTotal | number: "1.2-2" }}
            <span class="exact-divider">|</span> Round Off: ₹{{
              exactTotalRoundOff | number: "1.2-2"
            }}
          </span>
        </div>
        <button
          type="button"
          class="premium-btn premium-btn-secondary dialog-footer-close-btn"
          (click)="closeTotalDialogClicked.emit()"
          tabindex="301"
          aria-label="Close payment dialog"
        >
          Close · Esc
        </button>
        <button
          type="button"
          *ngIf="!showExchangeConfirmation"
          class="premium-btn premium-btn-success dialog-footer-process-btn"
          (click)="
            isQuotationMode
              ? processQuotationClicked.emit()
              : processPaymentClicked.emit()
          "
          [disabled]="
            isQuotationMode
              ? !canCompleteQuotation || isProcessingQuotation
              : !canCompletePayment
          "
          tabindex="302"
          [attr.aria-label]="
            isQuotationMode
              ? 'Process quotation and generate PDF'
              : 'Process payment and complete order'
          "
        >
          <i
            class="pi"
            [ngClass]="
              isQuotationMode && isProcessingQuotation
                ? 'pi-spinner pi-spin'
                : isQuotationMode
                  ? 'pi-file-edit'
                  : 'pi-check-circle'
            "
          ></i>
          {{ isQuotationMode ? "Process Quotation · Enter" : "Complete Payment · Enter" }}
        </button>
      </ng-container>

      <!-- Credit footer (part payment enabled) -->
      <ng-container *ngIf="isAnyPartPaymentEnabled && !isExchangeOrder">
        <span class="exact-round-card credit-summary">
          <i class="pi pi-credit-card"></i>
          Credit Amount:
          {{ currentPartPaymentAmount | currency: "INR" : "symbol" : "1.2-2" }}
          <span class="exact-divider">|</span> Credit Balance:
          {{ remainingCreditAmount | currency: "INR" : "symbol" : "1.2-2" }}
        </span>
        <button
          type="button"
          class="premium-btn premium-btn-secondary dialog-footer-close-btn"
          (click)="closeTotalDialogClicked.emit()"
          tabindex="301"
          aria-label="Close payment dialog"
        >
          Close
        </button>
        <button
          type="button"
          *ngIf="!showExchangeConfirmation"
          class="premium-btn premium-btn-success dialog-footer-process-btn"
          (click)="
            isQuotationMode
              ? processQuotationClicked.emit()
              : processPaymentClicked.emit()
          "
          [disabled]="
            isQuotationMode
              ? !canCompleteQuotation || isProcessingQuotation
              : !canCompletePayment
          "
          tabindex="302"
          [attr.aria-label]="
            isQuotationMode
              ? 'Process quotation and generate PDF'
              : 'Process part payment and add remaining to credit'
          "
        >
          <i
            class="pi"
            [ngClass]="
              isQuotationMode && isProcessingQuotation
                ? 'pi-spinner pi-spin'
                : isQuotationMode
                  ? 'pi-file-edit'
                  : 'pi-lock'
            "
          ></i>
          {{ isQuotationMode ? "Process Quotation" : "Process Credit" }}
        </button>
      </ng-container>
    </div>
    <!-- End of payment-dialog-wrapper -->
  </div>
</p-dialog>

<!-- Doctor Management Dialog (Pharmacy) -->
<app-doctor-management-dialog
  *ngIf="industryService.isPharmacy()"
  [(visible)]="showDoctorDialog"
  [initialData]="currentDoctorData"
  (doctorSaved)="onDoctorSaved($event)"
></app-doctor-management-dialog>
